import { Radio } from "@mui/material";
import { styled } from "@mui/material/styles";

export const RadioButton = styled(Radio)(() => ({
  color: "#D0D5DD",
  "&:hover": {
    backgroundColor: "transparent !important",
  },

  "&.Mui-checked": {
    "&:hover": {
      backgroundColor: "transparent !important",
    },
    color: "#308CDB !important",
  },

  "&.Mui-disabled": {
    color: "#D0D5DD !important",
  },
}));

export const RadioContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const EmptyState = styled("span")(() => ({
  padding: "0 16px",
}));
